import {
  SET_SELECTED_ASSET_ID,
  SET_SELECTED_CLIP_ID,
  SET_SELECTED_KEYFRAME_ID,
  SET_SELECTED_TRIGGER_ID,
  SET_HOVERED_TRIGGER_ID,
  SET_TRIGGER_AFFECTING_MODE_ID,
  SET_SELECTED_REACTIVE_ASSET_ID,
  SET_IS_CREATING_KEYFRAME,
  SET_IS_SELECTING_CLIP,
  SET_IS_ORBIT_VIEW,
  SET_IS_BLADE_MODE,
  type EditorSelectionActionTypes,
  type EditorSelectionState,
} from './editorSelectionActions';

const initialState: EditorSelectionState = {
  selectedAssetId: null,
  selectedClipId: null,
  selectedKeyframeId: null,
  selectedTriggerId: null,
  hoveredTriggerId: null,
  triggerAffectingModeId: null,
  selectedReactiveAssetId: null,
  isCreatingKeyframe: false,
  isSelectingClip: false,
  isOrbitView: true,
  isBladeMode: false,
};

const editorSelectionReducer = (
  state: EditorSelectionState = initialState,
  action: EditorSelectionActionTypes
): EditorSelectionState => {
  switch (action.type) {
    case SET_SELECTED_ASSET_ID:
      return { ...state, selectedAssetId: action.payload };
    case SET_SELECTED_CLIP_ID:
      return { 
        ...state, 
        selectedClipId: action.payload
      };
    case SET_SELECTED_KEYFRAME_ID:
      return {
        ...state,
        selectedKeyframeId: action.payload,
        // Selecting a keyframe clears trigger selection; deselecting (null) leaves it
        selectedTriggerId: action.payload ? null : state.selectedTriggerId,
        // Clear creating flag when a keyframe is selected
        isCreatingKeyframe: action.payload ? false : state.isCreatingKeyframe
      };
    case SET_SELECTED_TRIGGER_ID:
      return {
        ...state,
        selectedTriggerId: action.payload,
        selectedReactiveAssetId: null,
        // Clearing a trigger (null) must NOT wipe a clip/keyframe selected in the
        // same click, else the clip never shows after leaving a gate.
        ...(action.payload
          ? { selectedClipId: null, selectedKeyframeId: null, isCreatingKeyframe: false }
          : {}),
      };
    case SET_HOVERED_TRIGGER_ID:
      return { ...state, hoveredTriggerId: action.payload };
    case SET_TRIGGER_AFFECTING_MODE_ID:
      return { ...state, triggerAffectingModeId: action.payload };
    case SET_SELECTED_REACTIVE_ASSET_ID:
      return { ...state, selectedReactiveAssetId: action.payload };
    case SET_IS_CREATING_KEYFRAME:
      return { ...state, isCreatingKeyframe: action.payload };
    case SET_IS_SELECTING_CLIP:
      return { ...state, isSelectingClip: action.payload };
    case SET_IS_ORBIT_VIEW:
      return { ...state, isOrbitView: action.payload };
    case SET_IS_BLADE_MODE:
      return { ...state, isBladeMode: action.payload };
    default:
      return state;
  }
};

export default editorSelectionReducer;


